import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []
  
  connect() {
    this.currentIndex = 0
    this.images = []
    this.loadImages()
    document.addEventListener("keydown", this.handleKeyDown)
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown)
  }

  loadImages() {
    const galleryItems = document.querySelectorAll('.gallery-item')
    this.images = Array.from(galleryItems).map(item => ({
      src: item.dataset.src,
      index: parseInt(item.dataset.index)
    }))
  }
  
  handleKeyDown = (e) => {
    const modal = document.getElementById('gallery-modal')
    if (!modal.classList.contains('hidden')) {
      switch(e.key) {
        case "Escape":
          this.closeModal()
          break
        case "ArrowLeft":
          this.prevImage()
          break
        case "ArrowRight":
          this.nextImage()
          break
      }
    }
  }
  
  openModal(event) {
    event.preventDefault()
    
    const clickedIndex = parseInt(event.currentTarget.dataset.index)
    this.currentIndex = clickedIndex
    
    const modal = document.getElementById('gallery-modal')
    const modalImage = document.getElementById('modal-image')
    
    modalImage.src = this.images[this.currentIndex].src
    this.updateCounter()
    
    modal.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }
  
  closeModal() {
    const modal = document.getElementById('gallery-modal')
    modal.classList.add("hidden")
    document.body.style.overflow = ""
  }
  
  prevImage() {
    if (this.images.length === 0) return
    
    this.currentIndex = this.currentIndex === 0 
      ? this.images.length - 1 
      : this.currentIndex - 1
    
    this.updateModalImage()
  }
  
  nextImage() {
    if (this.images.length === 0) return
    
    this.currentIndex = this.currentIndex === this.images.length - 1 
      ? 0 
      : this.currentIndex + 1
    
    this.updateModalImage()
  }
  
  updateModalImage() {
    const modalImage = document.getElementById('modal-image')
    modalImage.src = this.images[this.currentIndex].src
    this.updateCounter()
  }
  
  updateCounter() {
    const counter = document.getElementById('image-counter')
    if (counter && this.images.length > 0) {
      counter.textContent = `${this.currentIndex + 1} de ${this.images.length}`
    }
  }
}